var submitForm = {
  // id: "",
  // createDate: "",
  // supervisorMessage: "",//监事信息JSON存储
  operatorMessage: "", //基本信息JSON存储
  legalMessage: "",//法人信息JSON存储
  directorMessage: "",//董事信息JSON存储
  shareholderMessage: "",//股东信息JSON存储
  liaisonMessage: "",//联络人信息JSON存储
  dlMessage: "",//指定代表/委托代理人 json存储
  financeMessage: "",//财务负责人信息JSON
  accountingType: "",//核算方式 1、独立核算 2 非独立核算
  sealFiling: "",//印章备案信息JSON
  remark: "", //其他需求事项
  marsterName: "",//申请事项1、食品经营许可证 2、食品小餐饮登记（经营场所面积不足五十平方米的餐饮服务经营者）3、卫生许可证 4、道路货物运输经营许可 5、出版物零售许可 6、户外招牌设施设置规范管理 7、创业补贴申领
  // onethingUrls: [
  //   {
  //     // id: "",
  //     // peopleOnethingId: "",
  //     fileUrls: "",
  //     fileKey: ""
  //   }
  // ],//材料信息
  entrepreneurialLoan: {
    // id: "",
    // peopleOnethingId: "",
    faName: "",//法人姓名
    idCard: "",//身份证号
    educationalAttainment: "",//文化程度
    totalAssetScale: "",//资产总规模（万元）
    debtRatio: "",//资产负债率
    annualRevenue: "",//年营收
    applyForCredit: "",//申请的额度
    employeesNumber: 0,//职工总人数
    placementNumber: 0//安置符合规定的人员数
  },
  industryHygieneLicense: {
    employeeNumber: 0,//员工人数
    physicalNumber: 0,//体检人数
    fixedAssets: "",//固定资产（万）
    usableArea: "",//使用面积
    isAirConditioning: "",//是否中央空调 0 无 1 有
    applyProject: "",//申请经营项目
    licenseScope: "",//许可范围
    // =====================食品经营======================
    prefabricatedFood: "",//预包装食品销售 0、含冷藏冷冻食品 1、含冷藏冷冻食品
    bulkFood: "",//散装食品销售 0、散装食品销售 1、含冷藏冷冻食品不含熟食 2、含冷藏冷冻食品不含熟食 3、不含冷藏冷冻食品不含熟食
    specialFood: "",//特殊食品销售 0、婴幼儿配方乳粉 1、其他婴幼儿配方食品 2、保健食品销售 3、保健食品销售 4、热食类食品制售 5、热食类食品制售 6、生食类食品制售 7、糕点类制售（含裱花蛋糕）8、糕点类制售（不含裱花蛋糕）9、自制饮品制售（不含使用压力容器制作饮品） 10、其他类食品销售
    isWine: "",//如申请自制饮品制售，是否含自酿酒制售 0 否 1 是
    vendingMachine: "",//如申请自制饮品制售，是否含自酿酒制售 0 否 1 是
    isNetwork: "",//是否含网络经营 0否 1 是
    technicalPersonnel: "",//安全、质量管理人员、专业技术人员情况（数组）
    practitionersLs: "",//从业人员信息 （数组）
    equipmentCcondition: "" //设备情况
  },
  outdoorAdvertising: {
    id: "",
    peopleOnethingId: "",
    name: "",
    longLeng: "",
    tallLong: "",
    houLong: ""
  },
  publicationInfo: {
    id: "",
    peopleOnethingId: "",
    name: "",
    usedArea: "",
    leasedArea: "",
    warehouseArea: "",
    computerMessage: "",
    publicationScope: "",
    practitionersLs: []
  },
  roadFreight: {
    // id: "",
    // peopleOnethingId: "",
    carType: "",
    carKd: "",
    carList: "",
    purchaseCarList: [],
    existingCarList: [],
    pilotList: []
  }
}

export default submitForm;